import { render, staticRenderFns } from "./MMailAuth.vue?vue&type=template&id=26d2ff9e&"
import script from "./MMailAuth.vue?vue&type=script&lang=ts&"
export * from "./MMailAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports